import { YESNO } from '@/utils/enum';
import { request } from '../core';
import { PageType } from '@/utils/enum';

export class FactoryApi {
  // 分页查询厂商数据列表
  fetchTableList({
    pageNum,
    pageSize,
    searchForm,
  }: {
    pageNum: number;
    pageSize: number;
    searchForm: Object;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/manufacturer/manufacturer_get_page_list',
      body: { ...searchForm, pageNum, pageSize },
    };
    return request(options);
  }
  //  新增编辑厂商
  submitFactory({
    type,
    requestBody,
  }: {
    type: PageType.EDIT | PageType.ADD;
    requestBody: Object;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path:
        type === PageType.EDIT
          ? '/k2/management/manufacturer/manufacturer_edit'
          : '/k2/management/manufacturer/manufacturer_add',
      body: requestBody,
    };
    return request(options);
  }
  // 查看厂商详情数据
  fetchFactoryDetail(id: number | string) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/manufacturer/manufacturer_get_detail',
      body: {
        id,
      },
    };
    return request(options);
  }
  // 变更厂商状态
  updateFactoryStatus({ id, enable }: { id: number; enable: YESNO }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/manufacturer/manufacturer_update_enable',
      body: {
        id,
        enable,
      },
    };
    return request(options);
  }

  getFactoryList(params: { property: string; enable: 0 | 1 }) {
    const options = {
      method: 'POST',
      path: '/k2/management/manufacturer/get_manufacturer_list',
      body: params,
    };
    return request(options);
  }
  getFactoryUser() {
    const options = {
      method: 'POST',
      path: '/k2/management/manufacturer/get_manufacturer_can_bind_user_list',
    };
    return request(options);
  }

  getPhone(params: { userName: string }) {
    const options = {
      method: 'POST',
      path: '/k2/management/manufacturer/get_manufacturer_bind_user_phone',
      body: params,
    };
    return request(options);
  }
}
